export * from './ordersTypes';
export * from './workQueueTypes';
export * from './newOrderTypes';
export * from './doneOrdersTypes';

const types = {
  userLogIn: '[USER] UserLogIn',
  clearUserData: '[USER] Clear user data',
  clearSaveStatus: '[USER] clear save status',
  addNewNotification: '[USER] add new notification',
  updateNotificationsPreference: '[USER] update notifications preference',
  markNotificationAsRead: '[USER] mark notification as read',
  markAllNotificationsAsRead: '[USER] mark all notifications as read',
  updateUserCurrentCompany: '[USER] update user current company',
  updateUserCurrentCompanyStatus: '[USER] update user current company status',
  saveUserProfile: '[USER] save user profile',
  openProfileManagerDialog: '[USER] open profile manager dialog',
  closeProfileManagerDialog: '[USER] close profile manager dialog',
  clearSaveUserProfileStatus: '[USER] clear save user profile status',
  clearVerificationCodeResent: '[USER] clear Verification Code Resent',
  sendVerificationCode: '[USER] send verification code',
  resendVerificationCode: '[USER] resend verification code',
  verifyCode: '[USER] verify code',
  openVerificationModal: '[USER] Open Verification Modal',
  getWorkOrderToPdf: '[WorkOrder] to pdf',
};
export default types;
